import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { pageUrls } from 'globalconfig/constants/keys';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ driverId, idPub }) => {
  return {
    comp_displayText: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'EXPORT DAILYLOG SIGNED STATUS',
      default: () => '',
    },
    comp_itemsPerPage: {
      [SERVICE_PROVIDERS.SPIREON]: () => 10,
      default: () => 15,
    },
    comp_totalSeperatorsp: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    comp_logBook_url: {
      [SERVICE_PROVIDERS.SPIREON]: () => `${pageUrls.logBook.replace(':id', idPub)}?driverId=${driverId}&logDay=`,
      default: () => pageUrls.logBook.replace(':id', idPub),
    },
    comp_isExportClicked: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
